module.exports = __webpack_public_path__ + "img/logo.44aa5219.png";